module.exports = __webpack_public_path__ + "static/img/product1.3baced7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product1.png
// module id = YHMn
// module chunks = 1